module.exports = __webpack_public_path__ + "img/Grupo 602@2x.8a199932.png";